module.exports = __webpack_public_path__ + "img/win_1.c7c63a55.png";